export function getUserList(data) {
    let { getUserListRequest, getUserListError, getUserListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'get_user_list',
        this.createBundle('get_user_list', { data: data }, this.GET, getUserListRequest, getUserListResult, getUserListError)
    )
}
